import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Container, FormGroup, Input, Label, Row, Table, Button, Badge } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { loadReport, downloadProductReport, downloadTipAndTaxesReport } from '../../../actions';
import {getPriceWithCurrencySymbol, renderOrderTypeSrc, renderPaymentTypeIcon} from '../../../utils/CommonUtils';

const reportMapping = {
    ordersByOrderType: {
        "1": {
            "text": i18n.t('screens:reportsScreen.orderTypesDataKeyMap.delivery'),
            "color": "000",
            "id": 1,
            "paymentType": false
        },
        "2": {
            "text": i18n.t('screens:reportsScreen.orderTypesDataKeyMap.collection'),
            "color": "000",
            "id": 2,
            "paymentType": false
        },
        "4": {
            "text": i18n.t('screens:reportsScreen.orderTypesDataKeyMap.curbside'),
            "color": "000",
            "id": 4,
            "paymentType": false
        },
        "5": {
            "text": i18n.t('screens:reportsScreen.orderTypesDataKeyMap.dineIn'),
            "color": "000",
            "id": 5,
            "paymentType": false
        }
    },
    ordersByStatus: {
        "1": {
            "text": i18n.t('screens:reportsScreen.orderTypesDataKeyMap.accepted'),
            "color": "rgb(117, 159, 46)",
        },

        "2": {
            "text": i18n.t('screens:reportsScreen.orderTypesDataKeyMap.rejected'),
            "color": "rgb(191, 30, 46)",
        },
        "5": {
            "text": i18n.t('screens:reportsScreen.orderTypesDataKeyMap.canceled'),
            "color": "rgb(191, 30, 46)",
        }
    },
    ordersByPayment: {
        "1": {
            "text": i18n.t('screens:reportsScreen.orderTypesDataKeyMap.creditCard'),
            "color": "000",
            "id": 1, // not real ID, just used for easiness
            "paymentType": true
        },
        "2": {
            "text": i18n.t('screens:reportsScreen.orderTypesDataKeyMap.cash'),
            "color": "000",
            "id": 2, // not real ID, just used for easiness
            "paymentType": true
        },
        "3": {
            "text": i18n.t('screens:reportsScreen.orderTypesDataKeyMap.loyalty'),
            "color": "000",
            "id": 3, // not real ID, just used for easiness
            "paymentType": true
        }
    }
};

const requestRange = {
    "TODAY": 1,
    "TOMORROW": 8,
    "YESTERDAY": 2,
    "THIS_WEEK": 3,
    "LAST_WEEK": 4,
    "THIS_MONTH": 5,
    "LAST_MONTH": 6,
    "CUSTOM": 7
};

class ReportsScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isRequestedReport: false,
            isRequestedCustomReport: false,
            startDate: null,
            endDate: null,
            startDateParsed: null,
            endDateParsed: null,
            chosenTimeRange: null,
            requestRangeSelection: null,
            productReportRange: null
        };

        this.reportRequest = this.reportRequest.bind(this);
    }

    componentDidMount() {
        this.reportRequest(requestRange.TODAY);
    }

    reportRequest(requestedRange) {
        let date = new Date();
        let startDate = new Date();
        let endDate = new Date();

        let startDD;
        let startMM;
        let startYYYY;

        let endDD;
        let endMM;
        let endYYYY;

        switch (requestedRange) {
            case requestRange.TODAY:
                setSingleDay(date);
                break;
            case requestRange.YESTERDAY:
                date.setDate(date.getDate() - 1);
                setSingleDay(date);
                break;
            case requestRange.TOMORROW:
                date.setDate(date.getDate() + 1);
                setSingleDay(date);
                break;
            case requestRange.THIS_WEEK:
                setWeek(date);
                break;
            case requestRange.LAST_WEEK:
                date.setDate(date.getDate() - 7);
                setWeek(date);
                break;
            case requestRange.THIS_MONTH:
                setMonth(date);
                break;
            case requestRange.LAST_MONTH:
                date.setDate(1);
                date.setMonth(date.getMonth() - 1);
                setMonth(date);
                break;
            case requestRange.CUSTOM:
                setFirstDay(this.state.startDateParsed);
                setLastDay(this.state.endDateParsed);
                break;
            default:
                break;
        }

        function setWeek(date) {
            startDate = getMonday(date);
            endDate.setDate(startDate.getDate() + 6);
            setFirstDay(startDate);
            setLastDay(endDate);
        }

        function setMonth(date) {
            startDate = new Date(date.getFullYear(), date.getMonth(), 1);
            endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            setFirstDay(startDate);
            setLastDay(endDate);
        }

        function getMonday(date) {
            date = new Date(date);
            let day = date.getDay(),
                diff = date.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
            return new Date(date.setDate(diff));
        }

        function setSingleDay(date) {
            setFirstDay(date);
            setLastDay(date);
        }

        function setFirstDay(date) {
            startDD = date.getDate();
            startMM = date.getMonth();
            startYYYY = date.getFullYear();
        }

        function setLastDay(date) {
            endDD = date.getDate();
            endMM = date.getMonth();
            endYYYY = date.getFullYear();
        }

        const { id } = this.props.match.params;

        let timeRange = {
            "startDate": `${startDD}-${startMM + 1}-${startYYYY} 00:00:00`,
            "endDate": `${endDD}-${endMM + 1}-${endYYYY} 23:59:59`
        };

        const dateTimeNow = new Date();
        let chosenTimeRange;
        if (dateTimeNow.getFullYear() <= endYYYY && dateTimeNow.getMonth() <= endMM && dateTimeNow.getDate() <= endDD) {
            let minutesNow = dateTimeNow.getMinutes().toString().length < 2 ? '0' + dateTimeNow.getMinutes() : dateTimeNow.getMinutes();
            let secondsNow = dateTimeNow.getSeconds().toString().length < 2 ? '0' + dateTimeNow.getSeconds() : dateTimeNow.getSeconds();
            chosenTimeRange = {
                "startDate": `${startDD}-${startMM + 1}-${startYYYY} ${requestedRange === requestRange.TODAY ? '00:00:00' : ''}`,
                "endDate": requestedRange === requestRange.TOMORROW ? timeRange.endDate : `${dateTimeNow.getDate()}-${dateTimeNow.getMonth() + 1}-${dateTimeNow.getFullYear()} ${dateTimeNow.getHours()}:${minutesNow}:${secondsNow}`
            }
        } else {
            chosenTimeRange = {
                "startDate": `${startDD}-${startMM + 1}-${startYYYY}`,
                "endDate": `${endDD}-${endMM + 1}-${endYYYY}`
            }
        }

        this.setState({
            ...this.state,
            isRequestedReport: true,
            isRequestedCustomReport: false,
            chosenTimeRange: chosenTimeRange,
            requestRangeSelection: requestedRange,
            productReportRange: timeRange
        });

        this.props.loadReport(id, timeRange);
    };

    customReportRequest() {
        this.setState({
            ...this.state,
            isRequestedCustomReport: true,
            requestRangeSelection: requestRange.CUSTOM
        });
    }

    renderReportRangeOptions() {
        const { summary, colElement, reportRangeOptionsRow, underline } = styles;
        const currentSelection = Object.assign({}, colElement, underline);

        return (
            <Row style={reportRangeOptionsRow}>
                <Col xs={7} sm={7} style={summary}>
                    <span
                        style={(this.state.requestRangeSelection === requestRange.TODAY) ? currentSelection : colElement}
                        onClick={() => this.reportRequest(requestRange.TODAY)}>{i18n.t('screens:reportsScreen.reportRangeToday')}</span>
                    <span
                        style={(this.state.requestRangeSelection === requestRange.YESTERDAY) ? currentSelection : colElement}
                        onClick={() => this.reportRequest(requestRange.YESTERDAY)}>{i18n.t('screens:reportsScreen.reportRangeYesterday')}</span>
                    <span
                        style={(this.state.requestRangeSelection === requestRange.TOMORROW) ? currentSelection : colElement}
                        onClick={() => this.reportRequest(requestRange.TOMORROW)}>{i18n.t('screens:reportsScreen.reportRangeTomorrow')}</span>
                    <span
                        style={(this.state.requestRangeSelection === requestRange.THIS_WEEK) ? currentSelection : colElement}
                        onClick={() => this.reportRequest(requestRange.THIS_WEEK)}>{i18n.t('screens:reportsScreen.reportRangeThisWeek')}</span>
                    <span
                        style={(this.state.requestRangeSelection === requestRange.LAST_WEEK) ? currentSelection : colElement}
                        onClick={() => this.reportRequest(requestRange.LAST_WEEK)}>{i18n.t('screens:reportsScreen.reportRangeLastWeek')}</span>
                    <span
                        style={(this.state.requestRangeSelection === requestRange.THIS_MONTH) ? currentSelection : colElement}
                        onClick={() => this.reportRequest(requestRange.THIS_MONTH)}>{i18n.t('screens:reportsScreen.reportRangeThisMonth')}</span>
                    <span
                        style={(this.state.requestRangeSelection === requestRange.LAST_MONTH) ? currentSelection : colElement}
                        onClick={() => this.reportRequest(requestRange.LAST_MONTH)}>{i18n.t('screens:reportsScreen.reportRangeLastMonth')}</span>
                    <span
                        style={(this.state.requestRangeSelection === requestRange.CUSTOM) ? currentSelection : colElement}
                        onClick={() => this.customReportRequest()}>{i18n.t('screens:reportsScreen.reportRangeCustom')}</span>
                </Col>
                <Col xs={5} sm={5} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        color='primary'
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginRight: 6 }}
                        onClick={() => this.props.downloadTipAndTaxesReport(this.props.match.params.id, this.state.productReportRange)}
                    >
                        <MaterialIcon icon="cloud_download" color="#fff" size={19} />
                        <div style={{ marginLeft: 5 }}>{i18n.t('screens:reportsScreen.downloadTipsAndTaxesReport')}</div>
                    </Button>
                    <Button
                        color='primary'
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                        onClick={() => this.props.downloadProductReport(this.props.match.params.id, this.state.productReportRange)}
                    >
                        <MaterialIcon icon="cloud_download" color="#fff" size={19} />
                        <div style={{ marginLeft: 5 }}>{i18n.t('screens:reportsScreen.downloadProductReport')}</div>
                    </Button>
                    {/* <Button
                        color='primary'
                        onClick={() => this.props.downloadProductReport(this.props.match.params.id, this.state.productReportRange)}
                        disabled={true}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <MaterialIcon icon="cloud_download" color="#fff" size={19} />
                            <div style={{ marginLeft: 5 }}>{i18n.t('screens:reportsScreen.downloadProductReport')}</div>
                        </div>
                        <div style={{ fontSize: 10 }}>(Under maintenance)</div>
                    </Button> */}
                </Col>
            </Row>
        );
    }

    getPrice(price) {
        return getPriceWithCurrencySymbol(price, this.props.restaurant.currency);
    }

    stringConvert(string) {
       if(string === "Pick up") {
           return "collection";
       } 
       if(string === "Dine pay") {
           return "dineIn"
       }
       const convertedString = string.charAt(0).toLowerCase() + string.slice(1).replace(' ', '');
       return convertedString;
    }

    renderReports() {
        const { singleReport } = styles;
        let orderTypes = this.props.loadedReports.orderTypes;

        return (
            Object.keys(orderTypes).map((orderType) => {
                return (
                    <div style={singleReport}>
                        <p style={{
                            textAlign: 'center',
                            fontWeight: 700
                        }}>{i18n.t(`screens:reportsScreen.orderTypes.${orderType}`)}</p>
                        <Table borderless={true}>
                            <thead>
                                <tr>
                                    <th>{i18n.t('screens:reportsScreen.common.type')}</th>
                                    <th style={{ textAlign: 'center' }}>{i18n.t('screens:reportsScreen.common.count')}</th>
                                    <th style={{ textAlign: 'right' }}>{i18n.t('screens:reportsScreen.common.totalAmount')}</th>
                                </tr>
                            </thead>
                            {Object.keys(orderTypes[orderType]).map((currentOrderType, i) => {
                                let currentOrderTypeData = reportMapping[orderType][currentOrderType];

                                if (currentOrderTypeData !== undefined) {
                                    return (
                                        <React.Fragment>
                                            <tr>
                                                <td className="reportTypeName"
                                                    style={{ color: currentOrderTypeData.color }}>
                                                    {(this.renderOrderTypeIcon(currentOrderTypeData))}
                                                    {<span style={{}}>{i18n.t(`screens:reportsScreen.orderTypesDataKeyMap.${this.stringConvert(currentOrderTypeData.text)}`)}</span>}
                                                </td>
                                                <td align="center">{orderTypes[orderType][currentOrderType].count}</td>
                                                <td align="right">{this.getPrice(Number(orderTypes[orderType][currentOrderType].totalAmount).toFixed(2))}</td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                }
                            })}
                        </Table>
                    </div>
                );
            })
        );
    }

    renderOrderTypeIcon(currentOrderTypeData) {
        if (currentOrderTypeData.id) {
            const paymentIconStyle = { position: 'relative', right: 8 };

            if (currentOrderTypeData.paymentType) {
                const reportScreen = currentOrderTypeData.id == 3 ? true : false;
                return renderPaymentTypeIcon(currentOrderTypeData.id,paymentIconStyle,null,reportScreen)
            } else {
                return renderOrderTypeSrc(currentOrderTypeData.id,paymentIconStyle)
            }
        } else {
            return null
        }

    }

    renderReportBody() {
        const { reportBody } = styles;

        if (!this.state.isRequestedReport && !this.state.isRequestedCustomReport) {
            return;
        }

        if (this.state.isRequestedCustomReport) {
            return (
                <React.Fragment>
                    {this.renderDatePickers()}
                </React.Fragment>
            );
        }

        return (
            <div style={reportBody}>
                {this.renderReportInfo()}
                {this.renderReports()}
                {this.renderAdditionalInformation()}
            </div>
        );
    }

    renderAdditionalInformation() {
        return (
            <div>*{i18n.t('screens:reportsScreen.additionalInfo')}</div>
        );
    }

    renderReportInfo() {
        const { reportInfoContainer, reportInfo } = styles;
        let loadedReports = this.props.loadedReports;

        return (
            <div style={reportInfoContainer}>
                <div style={reportInfo}>
                    {i18n.t('screens:reportsScreen.reportOrders.totalOrders')}:&nbsp;&nbsp;
                    <Badge color="primary" style={{ fontSize: 14 }}>&nbsp;{loadedReports.totalOrders}&nbsp;</Badge>&nbsp;&nbsp;&nbsp;&nbsp;
                    {i18n.t('screens:reportsScreen.reportOrders.totalOrdersAmount')}:&nbsp;&nbsp;
                    <Badge color="primary" style={{ fontSize: 14 }}>&nbsp;{this.getPrice(Number(loadedReports.totalOrdersAmount).toFixed(2))}&nbsp;</Badge>
                </div>
                <div style={reportInfo}>
                    {i18n.t('screens:reportsScreen.common.from')}:&nbsp;&nbsp;
                    {this.state.chosenTimeRange.startDate}&nbsp;&nbsp;&nbsp;&nbsp;
                    {i18n.t('screens:reportsScreen.common.to')}:&nbsp;&nbsp;
                    {this.state.chosenTimeRange.endDate}
                </div>
            </div>
        );
    }

    renderDatePickers() {
        let isDateBeforeNow = true;//new Date() >= this.state.startDateParsed && new Date() >= this.state.endDateParsed;

        return (
            <React.Fragment>
                <Row style={{ paddingTop: 40 }}>
                    <Col sm={3}>
                        <FormGroup row>
                            <Label for="startDate" style={styles.fromDatePickerLabel}
                                sm={3}>{i18n.t('screens:promotionValidityScreen.datePickerFrom')}</Label>
                            <Col sm={9}>
                                <Input
                                    type="date"
                                    name="startDate"
                                    id="startDate"
                                    placeholder="datetime placeholder"
                                    value={this.state.startDate}
                                    onChange={this.updateState.bind(this)}
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col sm={3}>
                        <FormGroup row>
                            <Label for="endDate" style={styles.toDatePickerLabel}
                                sm={3}>{i18n.t('screens:promotionValidityScreen.datePickerTo')}</Label>
                            <Col sm={9}>
                                <Input
                                    type="date"
                                    name="endDate"
                                    id="endDate"
                                    placeholder="datetime placeholder"
                                    value={this.state.endDate}
                                    onChange={this.updateState.bind(this)}
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                    <Col sm={3}>
                        <Button
                            color='primary'
                            onClick={() => this.reportRequest(requestRange.CUSTOM)}
                            disabled={!(this.state.startDateParsed && this.state.endDateParsed) || (this.state.startDateParsed > this.state.endDateParsed || !isDateBeforeNow)}
                        >{i18n.t('screens:reportsScreen.common.confirmButton')}</Button>
                    </Col>
                </Row>
                {((this.state.startDateParsed > this.state.endDateParsed) && this.state.startDateParsed && this.state.endDateParsed) ? (
                    <Row>
                        <Col sm={12}>
                            <p style={{ color: 'red' }}>{i18n.t('screens:reportsScreen.common.dateOrderErrorMessage')}</p>
                        </Col>
                    </Row>
                ) :
                    (!isDateBeforeNow && this.state.startDateParsed && this.state.endDateParsed) ? (
                        <Row>
                            <Col sm={12}>
                                <p style={{ color: 'red' }}>{i18n.t('screens:reportsScreen.common.dateAfterCurrentErrorMessage')}</p>
                            </Col>
                        </Row>
                    ) : null
                }
            </React.Fragment>
        );
    }

    static parseDate(date) {
        let b = date.split(/\D/);
        return new Date(b[0], --b[1], b[2]);
    }

    updateState({ target }) {
        this.setState({
            ...this.state,
            [target.name]: [target.value],
            [`${[target.name]}Parsed`]: ReportsScreen.parseDate(target.value)
        });
    }

    render() {
        const { containerStyle } = styles;

        return (
            <Container fluid style={containerStyle}>
                {this.renderReportRangeOptions()}
                {this.renderReportBody()}
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        loadedReports: state.loadedReports,
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, { loadReport, downloadProductReport, downloadTipAndTaxesReport })(ReportsScreen);

const styles = {
    underline: {
        textDecoration: 'underline'
    },
    reportBody: {
        paddingTop: 34,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between'
    },
    reportInfoContainer: {
        width: '100%',
        marginBottom: 30,
        boxShadow: '1px 6px 24px 0px rgba(0,0,0,0.4)',
        display: 'flex',
        justifyContent: 'space-between'
    },
    reportInfo: {
        padding: 20,
        fontSize: 14,
    },
    singleReport: {
        marginBottom: 15,
        padding: 10,
        boxShadow: '1px 6px 24px 0px rgba(0,0,0,0.4)',
        width: 'calc(100% / 3 - 20px)',
    },
    containerStyle: {
        padding: "0 0 0 10px"
    },
    reportRangeOptionsRow: {
        paddingTop: 33
    },
    colElement: {
        marginRight: 20,
        color: '#0288D1',
        cursor: 'pointer',
        fontSize: 14
    },
    dealTypeText: {
        paddingTop: 4
    },
    fromDatePickerLabel: {
        position: 'relative',
        top: 5
    },
    toDatePickerLabel: {
        position: 'relative',
        top: 5
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/reports/ReportsScreen.js